import { render, staticRenderFns } from "./DiscountPolicyTab.vue?vue&type=template&id=c3020670&scoped=true&"
import script from "./DiscountPolicyTab.vue?vue&type=script&lang=js&"
export * from "./DiscountPolicyTab.vue?vue&type=script&lang=js&"
import style0 from "./DiscountPolicyTab.vue?vue&type=style&index=0&id=c3020670&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3020670",
  null
  
)

export default component.exports